import { mediaQueryUp } from 'components/utils/breakpoint'
import Group from 'components/utils/Group'
import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'
import { accommodationIndividualRoomTileGridChildEnforcer } from './AccommodationIndividualRoomRoomTileGridBase'

export const AccommodationIndividualRoomTilePricingContainer = styled(Group)`
  ${accommodationIndividualRoomTileGridChildEnforcer}
  position: relative;

  margin-top: ${rem(8)};
  ${mediaQueryUp.desktop} {
    margin-top: unset;
  }
`

interface Props extends React.ComponentProps<typeof Group> {}

function AccommodationIndividualRoomTilePricing({ children, ...rest }: React.PropsWithChildren<Props>) {
  return <AccommodationIndividualRoomTilePricingContainer {...rest}>
    {children}
  </AccommodationIndividualRoomTilePricingContainer>
}

export default AccommodationIndividualRoomTilePricing
